// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#editControllingModal .input-editable {
  width: 75%;
  display: inline-block;
  max-height: 150px;
  min-height: 30px;
}
#editControllingModal .edit-wrapper {
  width: 77%;
  max-width: 250px;
  word-break: break-word;
  overflow-y: auto;
  max-height: 200px;
}
#editControllingModal .icon-cancel {
  color: #0078dc;
  font-size: 2.08rem;
  padding-right: 6px;
  position: relative;
}
#editControllingModal .icon-times {
  color: red;
  font-size: 2.08rem;
  padding-right: 6px;
  position: relative;
}
#editControllingModal input, #editControllingModal textarea {
  background-color: white;
  padding-left: 5px;
  outline: none;
  border: 1px solid darkgray !important;
  text-align: left;
  border-radius: 5px;
  width: 100%;
}
#editControllingModal .is-invalid {
  border: 1px solid red !important;
}
#editControllingModal .invalid-feedback ~ .is-invalid {
  display: block;
}
#editControllingModal table.planning-table th {
  border-right: 1px solid #adadad;
  border-bottom: 1px solid #adadad;
  text-align: center;
}
@media (min-width: 1023px) {
#editControllingModal table.planning-table th {
    width: 130px;
    padding: 15px;
}
}
#editControllingModal table.planning-table th:last-child {
  border-right: none;
}
#editControllingModal table.planning-table td {
  border-right: 1px solid #adadad;
  text-align: left;
  padding: 15px 9px;
  text-align: center;
  background-color: #f9f9f9;
}
#editControllingModal table.planning-table td:first-child {
  width: 37%;
}
#editControllingModal table.planning-table td:last-child {
  border-right: none;
}
#editControllingModal table.planning-table tr:nth-child(even) td {
  background-color: white;
}
#editControllingModal .btn {
  border-radius: 30px;
  min-width: 115px;
  box-shadow: none !important;
}
#editControllingModal .disabledDelete {
  opacity: 0.3;
}
#editControllingModal {
  /* Create a custom checkbox */
}
#editControllingModal .checkmark {
  position: absolute;
  margin-left: -15px;
  height: 20px;
  width: 20px;
  border: 2px solid #d0d0d0;
  border-radius: 4px;
}
#editControllingModal label {
  font-size: 1.6rem !important;
}
#editControllingModal {
  /* When the checkbox is checked, add a blue background */
}
#editControllingModal .container input:checked ~ .checkmark {
  background-color: #2196F3;
  border: 2px solid #2196F3;
}
#editControllingModal {
  /* Create the checkmark/indicator (hidden when not checked) */
}
#editControllingModal .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
#editControllingModal {
  /* Show the checkmark when checked */
}
#editControllingModal .container input:checked ~ .checkmark:after {
  display: block;
}
#editControllingModal {
  /* Style the checkmark/indicator */
}
#editControllingModal .container .checkmark:after {
  left: 6px;
  top: 0px;
  width: 5px;
  height: 14px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
#editControllingModal .container.radio {
  width: fit-content !important;
  padding: 0 50px;
}
#editControllingModal .checkmark {
  margin-left: -26px;
  margin-top: 3px;
}
#editControllingModal .btn-link {
  color: #5b5b5b;
  font-weight: bold;
}
#editControllingModal .btn-link:hover {
  text-decoration: none;
  color: #5a5a5a;
}
#editControllingModal .btn-link:focus {
  text-decoration: none;
}
#editControllingModal .btn-secondary {
  border-radius: 0;
  background-color: #b4b4b4;
  box-shadow: none !important;
  border: none;
}
#editControllingModal .btn-primary {
  border-radius: 30px;
  min-width: 115px;
  box-shadow: none !important;
}
@media (min-width: 2024px) {
#editControllingModal #confirmation-modal-label {
    font-size: 3.2rem;
}
}
@media (min-width: 2024px) {
#editControllingModal .invalid-feedback span {
    font-size: 1.84rem !important;
}
}
@media (min-width: 2024px) {
#editControllingModal .modal-dialog {
    max-width: 700px !important;
}
}
@media (min-width: 2024px) {
#editControllingModal .modal-dialog .input-group input {
    font-size: 1.84rem !important;
}
}
@media (min-width: 2024px) {
#editControllingModal .modal-dialog .modal-footer button.btn {
    font-size: 1.84rem !important;
}
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
